export default __webpack_public_path__ + "static/media/11-64.1d32d595.png";